import React from 'react';
import {MasterLayout} from 'components/layouts';
import {RegisterForm} from 'components/register';
import title from 'constants/TitlePages.js';

class Register extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.signup;
  }

  render() {
    return (
      <MasterLayout isActive='signup'>
        <RegisterForm/>
      </MasterLayout>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./pages/Register.jsx